import { Component, Optional, Input,EventEmitter,Output,ViewChild, ViewEncapsulation, ElementRef, OnInit, ChangeDetectorRef } from "@angular/core";
import { NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import { WebResService } from '../../webresolution/service/webresservices';
import { AuthService } from '../../core/auth-service.component';
import {MessageBox} from '../../commoncomponent/MessageBox/MessageBox';
import { InvoiceAttachmentsDTO } from "../model/InvoiceAttachmentsDTO";
import { InvoiceDTO } from "../model/InvoiceDTO";
import { HttpResponse, HttpErrorResponse, HttpHeaders } from "@angular/common/http";
import { FormGroup, UntypedFormBuilder } from "@angular/forms";
import { EnvService } from "src/app/core/env.service";
import { DownloadFileModalComponent } from "./downloadFile.component";
import { GridDataResult } from "@progress/kendo-angular-grid";
import { InvoiceShipmentDTO } from "@models/InvoiceShipmentDTO";
import { AppService } from "@global/app.service";

@Component({
    selector: "app-attachmodal",
    styleUrls: ['../webres.scss'],
    templateUrl: "./viewAttachment.component.html",
    encapsulation: ViewEncapsulation.None
})
export class ViewAttachmentModalComponent implements OnInit{
  public invDetails:any;
  public invdata:Array<InvoiceDTO> = [];
  public showList:boolean = true;
  public shipmentGridView: GridDataResult;
  public invShipment: Array<InvoiceShipmentDTO>;
  public skip = 0;
  public pageSize = 10;
  public showIframeLoader:boolean = false;
  @Input() commaSeparatedInvId: any;
  @Input() invs:Array<InvoiceDTO> = [];
  @ViewChild('noimg', {static: false}) noimg: ElementRef;
  @ViewChild('invoicePDF', {static: false}) invoicePDF: ElementRef;
  style: string;
  public allocation:string="";
  
  constructor(private fb: UntypedFormBuilder, private _authService: AuthService,public _env: EnvService, private _webResService: WebResService, private _cd: ChangeDetectorRef,
              @Optional() private readonly activeModal: NgbActiveModal,private _messageBox:MessageBox,private _appService: AppService) { }

  ngOnInit() {
    this._webResService.getInvoiceByIdPromise(this.commaSeparatedInvId)
    .subscribe((data) => {
      this.invDetails = data;
      this._cd.detectChanges();
    });   
  }
  
  public openInvoice(filename,invoiceId){
    this._webResService.getWebResAttachmentOpenPDF(filename,"n",invoiceId).subscribe((blobObj) =>{
      var url = window.URL.createObjectURL(blobObj);
      window.open(url);
    },
    (err) => {
      this._messageBox.open("No Invoice Image Available!");
      console.log("error: " + err.error);
    });
  }
  public openDownload(invoiceId){
    const modal: any =   this._messageBox.openSMoModal(DownloadFileModalComponent);
    let modalComponent = modal.componentInstance;
    modalComponent.invoiceId = invoiceId;
  }
  public viewClickDisplay1(data): void {
    let invoiceId = data;
    let theFile
   this._webResService.getInvoiceByIdPromise(invoiceId)
   .subscribe((data) => {
    this.showList = false;
     this.invDetails = data;
     this.shipmentGridView = {
         data: this.invDetails.Shipments.slice(this.skip, this.skip + this.pageSize),
         total: this.invDetails.Shipments.length
     };
     this.invShipment = data.Shipments;
     this.showIframeLoader = true;

     this._cd.detectChanges();

     this._webResService.getWebResAttachmentOpenPDF(this.invDetails.InvoiceFile,"n",invoiceId).subscribe((blobObj) => 
     {
       theFile = new Blob([blobObj], { type: 'application/octet-stream' });
       this.noimg.nativeElement.style.display = 'none';
       this.invoicePDF.nativeElement.style.display = 'block';
       if (window.navigator && window.navigator.msSaveOrOpenBlob) {
         window.navigator.msSaveOrOpenBlob(theFile, this.invDetails.InvoiceFile+'.pdf');
       } else {
        var url = window.URL.createObjectURL(blobObj);
         window.open(url, "invoicePDFframe");
       }
       this.showIframeLoader = false;

     },
     (err) => {
         console.log(err);
         this.style ='<div style="margin-top: -50%;padding-top: 20px;overflow:hidden"><center><img src="/assets/images/alert/No-image-available.png"></center></div>';
         this.noimg.nativeElement.innerHTML = this.style;
         this.invoicePDF.nativeElement.style.display = 'none';
         this.showIframeLoader = false;
     });

     this._appService.getAllocation(invoiceId).subscribe((data)=>{
      this.allocation = data.Value;
    });
   },
   (err) => {
     if(err.status === 400){
       this._messageBox.open(err.error.Message);
       console.log(err.error);
     }
   });
  }
  public dismiss(): void {
      if (this.activeModal)
        this.activeModal.dismiss();
  }
} 
